<aside class="order-summary" aria-label="Resumen del pedido">
  <header class="order-summary__header">
    <h2 class="order-summary__title color-primary mb-0">
      {{ title() }}
    </h2>
  </header>

  <div class="order-summary__body">
    <dl *ngIf="items() as summaryItems" class="order-summary__list">
      <ng-container *ngFor="let item of summaryItems">
        <div
          class="order-summary__item"
          [class.order-summary__item--total]="item.isTotal"
        >
          <dt class="order-summary__label">
            {{ item.label }}
          </dt>
          <dd class="order-summary__value">
            {{ item.value }}
          </dd>
        </div>
      </ng-container>
    </dl>
  </div>
</aside>

